import React, { useEffect, useState } from "react";
import BenefitsMemberBanner from "../components/benefitsmember/BenefitsMemberBanner";
import { useLoader } from "../context/LoaderContext";
import {
  IBannerData,
  IBenefitsMemberFromData,
  IBenefitsMemberTabData,
} from "../exports/interfaces";
import {
  fetchBenefitsMemberBanner,
  fetchBenefitsMemberFrom,
  fetchBenefitsMemberTabs,
} from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";

import BenefitsMemberFrom from "../components/benefitsmember/BenefitsMemberFrom";
import BenefitsMemberTab from "../components/benefitsmember/BenefitsMemberTab";

const BenefitsMember = () => {
  const { setLoading } = useLoader();
  const [benefitsMememberBannerData, setBenefitsMememberBannerData] = useState<
    IBannerData[]
  >([]);
  const [benefitsMemberData, setBenefitsMemberData] = useState<
    IBenefitsMemberFromData[]
  >([]);
  const [benefitsMemberTabData, setBenefitsMemberTabData] = useState<
    IBenefitsMemberTabData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchBenefitsMemberBanner(),
      fetchBenefitsMemberFrom(),
      fetchBenefitsMemberTabs(),
    ])
      .then(
        ([
          benefitsMemberBannerData,
          benefitsMemberFromData,
          benefitsMemberTabData,
        ]) => {
          setBenefitsMememberBannerData(benefitsMemberBannerData);
          setBenefitsMemberData(benefitsMemberFromData);
          setBenefitsMemberTabData(benefitsMemberTabData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [benefitsMememberBannerData.length, setLoading]);
  return (
    <>
      <BenefitsMemberBanner
        benefitsMememberBannerData={benefitsMememberBannerData}
      />
      <BenefitsMemberFrom benefitsMemberData={benefitsMemberData} />
      <BenefitsMemberTab benefitsMemberTabData={benefitsMemberTabData} /> 
    </>
  );
};

export default BenefitsMember;
